import React from "react";
import Infosection from "../componentes/Infosection";
import TestimoniosSection from "../componentes/TestimoniosSection";
import ImagySection from "../componentes/ImagySection";
import 'react-medium-image-zoom/dist/styles.css';
import Contacto from './Contacto';
import Planes from '../componentes/Planes';
import ComparativaPlanes from "../componentes/ComparativaPlanes";
import PreguntasFrecuentes from "../componentes/PreguntasFrecuentes";
import PersonalizaImagy from "../componentes/ImagyMarquee";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import DashboardInfo from '../componentes/DashboardInfo';
import BotDashboardInfo from '../componentes/BotDashboardInfo';
import NuestroEquipo from '../componentes/NuestroEquipo';

// ⬇️ NUEVO: importá el formulario de configuración
// import FormularioConfigNegocio from "../formularios/FormularioConfigNegocio";

function HomeLanding() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      {/* 🟠 Hero Section */}
      <div id="inicio" style={{ backgroundColor: "#FFF3E0" }}>
        <Infosection title="Bienvenidos a IMAGINA Soluciones IT" />
        {/* ⬇️ NUEVO: CTA para ir al form de configuración */}
        {/* <div style={{ textAlign:'center', padding:'12px 16px 24px' }}>
          <button
            onClick={() => scrollTo('config-negocio')}
            style={{
              padding: '12px 18px',
              border: 'none',
              borderRadius: '30px',
              backgroundImage: 'linear-gradient(to right, #FF7A00, #FFB347)',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: '16px',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
            }}
          >
            Cargar datos del negocio
          </button>
        </div> */}
      </div>

      {/* 🔷 Sección Imagy + Testimonios */}
      <div id="imagy">
        <ImagySection />
      </div>
    
      <div id="DashboardInfo">
        <DashboardInfo />
      </div>
      <div>
        <BotDashboardInfo />
      </div>
      <div id="personaliza">
        <PersonalizaImagy />
      </div>

      {/* 💼 Planes */}
      <div id="planes">
        <Planes />    
      </div>

      {/* 🟧 Comparativa */}
      <div id="comparativa">
        <ComparativaPlanes />
      </div>

      <div>
        <TestimoniosSection />
      </div>

      <section id="equipo">
        <NuestroEquipo />
      </section>

      {/* ⬇️ NUEVO: Sección Configuración del Negocio */}
      <div id="config-negocio" style={{ marginTop: 40 }}>
        {/* <FormularioConfigNegocio /> */}
      </div>

      {/* ❓ Preguntas Frecuentes */}
      <div id="faq">
        <PreguntasFrecuentes />
      </div>

      {/* 📞 Contacto */}
      {/* <div id="contacto">
        <Contacto />
      </div> */}

      {/* ✅ Botón flotante WhatsApp */}
      <a 
        href="https://wa.me/5491154688697?text=Hola%20quiero%20más%20info%20sobre%20Imagy" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#25D366',
          color: 'white',
          padding: '12px',
          borderRadius: '50%',
          textDecoration: 'none',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
          zIndex: 9999
        }}
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="WhatsApp"
          style={{ width: "28px", height: "28px" }}
        />
      </a>
    </>
  );
}

export default HomeLanding;
